import request from '@/api/request.js'

const apis = {
  read() {
    return request({ url: `/admin_license_key/read`, method: 'GET' })
  },
  updatePolicy(params) {
    return request({ url: `/admin_license_key/updatePolicy`, method: 'POST', data: params })
  },
  updateCurrentKeyId(params) {
    return request({ url: `/admin_license_key/updateCurrentKeyId`, method: 'POST', data: params })
  },
  uploadCurrentPrivate(data) {
    return request({ url: `/admin_license_key/uploadCurrentPrivate`, method: 'POST', data })
  },
  uploadCurrentPublic(data) {
    return request({ url: `/admin_license_key/uploadCurrentPublic`, method: 'POST', data })
  },
  uploadTrustRootPublic(data) {
    return request({ url: `/admin_license_key/uploadTrustRootPublic`, method: 'POST', data })
  },
  uploadKeyset(data) {
    return request({ url: `/admin_license_key/uploadKeyset`, method: 'POST', data })
  },
  testCurrentKeypair() {
    return request({ url: `/admin_license_key/testCurrentKeypair`, method: 'POST' })
  },
  testSignedKeyset() {
    return request({ url: `/admin_license_key/testSignedKeyset`, method: 'POST' })
  },
}

export default apis
